import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
import { useParams } from "react-router-dom";

// การ์ดสรุปเช็คชื่อ 1 คาบ สำหรับมุมมองมือถือ
const AttendanceCard = ({ attendance, teach_id }) => (
  <div className="border rounded p-3">
    <div className="d-flex align-items-center justify-content-between gap-2">
      <div className="fw-semibold">{attendance.att_day} {attendance.att_date}</div>
      <span className="fs-xs text-muted">คาบที่ {attendance.period_order}</span>
    </div>
    <div className="d-flex flex-wrap gap-3 mt-2 pt-2 border-top fs-sm">
      <div><span className="text-muted">ทั้งหมด:</span> <strong>{attendance.total_students}</strong></div>
      <div className="text-success">มา {attendance.presents}</div>
      <div className="text-warning">สาย {attendance.lates}</div>
      <div className="text-info">ลา {attendance.leaves}</div>
      <div className="text-danger">ขาด {attendance.absents}</div>
    </div>
    <div className="mt-2 pt-2 border-top">
      <Link to={`/teaching/edit-attendance/${teach_id}/${attendance.att_date_raw}/${attendance.period_id}`}
        className="btn btn-outline-primary btn-sm w-100">
        <i className="ri-edit-2-fill me-1" />แก้ไข
      </Link>
    </div>
  </div>
)

export default function ListAttendance() {

  const { teach_id } = useParams();
  const { setLoading } = useLoading();
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');
      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead');
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const [data, setData] = useState([]);
  const [room, setRoom] = useState("");
  const [subject, setSubject] = useState("");
  const [yearDisplay, setYearDisplay] = useState("");
  const [view, setView] = useState(() =>
    (typeof window !== 'undefined' && window.innerWidth < 768) ? 'card' : 'table')

  useEffect(() => {
    const yearId = localStorage.getItem('yearId');
    if (!yearId) return;
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    })
    .then(res => {
      const found = res.data.find(y => String(y.year_id) === String(yearId));
      if (found) setYearDisplay(`ปีการศึกษา ${found.year_year}`);
    })
    .catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);

    axiosInstance.get(`${process.env.REACT_APP_API}/getSubjectAndRoomByTeachId/${teach_id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    })
    .then(response => {
      const { tb_class_c_id, r_no, sub_subid, sub_subname } = response.data[0];
      setSubject(sub_subid + " " + sub_subname);
      setRoom(tb_class_c_id + "/" + r_no);
    })
    .catch(error => {
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: error.response ? error.response.data.message : 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้'
      });
    })
    .finally(() => {
      setLoading(false);
    })
  }, [teach_id, setLoading]);

  useEffect(() => {
    setLoading(true);
    
    axiosInstance.get(`${process.env.REACT_APP_API}/summarizeAttendanceByTeachId/${teach_id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    })
    .then(response => {
      console.log("Response Data:", response.data);
      setData(response.data);
    })
    .catch(error => {
      // console.error("Error:", error);
      Swal.fire({
        icon: 'error',
        title: error.response.data.title || 'เกิดข้อผิดพลาด',
        text: error.response ? error.response.data.message : 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้'
      })
    })
    .finally(() => {
      setLoading(false);
    });
  }, [teach_id, setLoading]);


  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ข้อมูลการสอน</Link></li>
              <li className="breadcrumb-item"><Link to="#">ข้อมูลการเช็คชื่อ</Link></li>
              <li className="breadcrumb-item active" aria-current="page">ชั้น ม.{room}</li>
            </ol>
            <h4 className="main-title mb-0">แสดงการเช็คชื่อชั้น <u>ม.{room}</u> วิชา <u>{subject}</u></h4>
          </div>
          {yearDisplay && (
            <div className="text-end mt-2 mt-sm-0">
              <span className="badge bg-primary fs-6 fw-normal">{yearDisplay}</span>
            </div>
          )}
        </div>

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header className="d-flex align-items-center justify-content-end gap-2">
                <div className="btn-group btn-group-sm" role="group" aria-label="สลับมุมมอง">
                  <button type="button" className={`btn btn${view === 'table' ? '' : '-outline'}-primary`}
                    onClick={() => setView('table')} title="มุมมองตาราง">
                    <i className="ri-table-line" />
                  </button>
                  <button type="button" className={`btn btn${view === 'card' ? '' : '-outline'}-primary`}
                    onClick={() => setView('card')} title="มุมมองการ์ด">
                    <i className="ri-layout-grid-line" />
                  </button>
                </div>
              </Card.Header>
              <Card.Body className="p-3">
                {data && data.length === 0 ? (
                  <div className="text-center py-3">ไม่พบข้อมูล</div>
                ) : view === 'card' ? (
                  <Row className="g-3">
                    {data.map((attendance, index) => (
                      <Col key={index} xs={12} md={6} xl={4}>
                        <AttendanceCard attendance={attendance} teach_id={teach_id} />
                      </Col>
                    ))}
                  </Row>
                ) : (
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center" style={{ width:"150px" }}>วันที่</th>
                      <th scope="col" className="text-center" style={{ width: "100px" }}>คาบที่</th>
                      <th scope="col" className="bg-secondary text-center" style={{ width: "100px" }}>นักเรียนทั้งหมด</th>
                      <th scope="col" className="bg-success text-center" style={{ width: "50px" }}>มา</th>
                      <th scope="col" className="bg-warning text-center" style={{ width: "50px" }}>สาย</th>
                      <th scope="col" className="bg-info text-center" style={{ width: "50px" }}>ลา</th>
                      <th scope="col" className="bg-danger text-center" style={{ width: "50px" }}>ขาด</th>
                      <th scope="col" className="text-center" style={{ width: "80px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((attendance, index) => (
                      <tr key={index}>
                        <th scope="row" className="text-center">{attendance.att_day + " " + attendance.att_date}</th>
                        <td className="text-center">{attendance.period_order}</td>
                        <td className="bg-secondary text-center">{attendance.total_students}</td>
                        <td className="bg-success text-center">{attendance.presents}</td>
                        <td className="bg-warning text-center">{attendance.lates}</td>
                        <td className="bg-info text-center">{attendance.leaves}</td>
                        <td className="bg-danger text-center">{attendance.absents}</td>
                        <td className="text-center">
                          <Link to={`/teaching/edit-attendance/${teach_id}/${attendance.att_date_raw}/${attendance.period_id}`}><i className="ri-edit-2-fill"></i> แก้ไข</Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  );
}
